import { Avatar, Group, Menu, Text } from "@mantine/core";
import { IconKey, IconLogout, IconUserCircle } from "@tabler/icons-react";
import CustomText from "components/ui/CustomText/CustomText";
import { FC, useRef } from "react";
import { useDispatch } from "react-redux";
import { logout } from "redux/auth/slice";
import { useProfile } from "utils/hooks";
import { useAppModal } from "utils/hooks/ui/useAppModal";
import { useStorageFileUrl } from "utils/hooks/request/useStorageFileUrl";
import ChangePasswordModal, {
  CHANGE_PASSWORD_FORM_ID,
} from "./ChangePasswordModal/ChangePasswordModal";
import ProfileModal, { PROFILE_FORM_ID } from "./ProfileModal/ProfileModal";

const ICON_SIZE = 14;

export const UserMenu: FC = () => {
  const dispatch = useDispatch();
  const { profile, mutate } = useProfile();
  const { openCrudModal, closeCrudModal } = useAppModal();
  const activeModalId = useRef<string | null>(null);

  const handleCloseModal = () => {
    if (activeModalId.current) {
      closeCrudModal(activeModalId.current);
      activeModalId.current = null;
    }
  };

  const handleOpenProfileModal = () => {
    if (!profile) return;
    const modalId = openCrudModal(
      <CustomText variant="section-title">Hồ sơ của tôi</CustomText>,
      {
        mode: "edit",
        formId: PROFILE_FORM_ID,
        children: (
          <ProfileModal
            profile={profile}
            mutate={mutate}
            onClose={handleCloseModal}
          />
        ),
        submitText: "Lưu",
      },
      500,
    );
    activeModalId.current = modalId;
  };

  const handleOpenChangePasswordModal = () => {
    const modalId = openCrudModal(
      <CustomText variant="section-title">Đổi mật khẩu</CustomText>,
      {
        mode: "edit",
        formId: CHANGE_PASSWORD_FORM_ID,
        children: <ChangePasswordModal onClose={handleCloseModal} />,
        submitText: "Đổi mật khẩu",
      },
      450,
    );
    activeModalId.current = modalId;
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const avatarLabel = profile?.fullname?.charAt(0)?.toUpperCase() ?? "U";
  const { url: avatarUrl } = useStorageFileUrl(profile?.avatarKey);

  return (
    <Menu shadow="md">
      <Menu.Target>
        <Group style={{ cursor: "pointer" }} gap="xs">
          <Avatar size="md" radius="xl" src={avatarUrl}>
            {avatarLabel}
          </Avatar>
          <Text fw={500}>{profile?.fullname}</Text>
        </Group>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Label>Thông tin</Menu.Label>

        <Menu.Item onClick={handleOpenProfileModal}>
          <Group gap="xs">
            <IconUserCircle size={16} />
            <Text>Hồ sơ của tôi</Text>
          </Group>
        </Menu.Item>

        <Menu.Item onClick={handleOpenChangePasswordModal}>
          <Group gap="xs">
            <IconKey size={ICON_SIZE} />
            <Text>Đổi mật khẩu</Text>
          </Group>
        </Menu.Item>

        <Menu.Item onClick={handleLogout}>
          <Group gap="xs">
            <IconLogout size={ICON_SIZE} />
            <Text>Đăng xuất</Text>
          </Group>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
